import { Card, CardBody, Col } from "reactstrap";
import { timelineMainSubTitle } from "../../../../Data/BonusUi/Timeline";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { TimelineTitle } from "../../../../Utils/Constants";
import AppIdeasTimeline from "./AppIdeasTimeline";
import AutoTestingTimeline from "./AutoTestingTimeline";
import BlogTimeline from "./BlogTimeline";
import CarouselTimeline from "./CarouselTimeline";
import MeetUpTimeline from "./MeetUpTimeline";
import ResolutionTimeline from "./ResolutionTimeline";

export default function TimelineMain() {
  return (
    <Col sm={12}>
      <Card>
        <CommonCardHeader title={TimelineTitle} subTitle={timelineMainSubTitle} />
        <CardBody>
          <section className="cd-container" id="cd-timeline">
            <AppIdeasTimeline />
            <BlogTimeline />
            <CarouselTimeline />
            <AutoTestingTimeline />
            <MeetUpTimeline />
            <ResolutionTimeline />
          </section>
        </CardBody>
      </Card>
    </Col>
  );
}
